import "./../css/raziskuj-clanke.scss";
import $ from "jquery";

/*global vars*/
/*eslint no-undef: "error"*/

$(document).ready(function ($) {
    function humanReadableEncode(str) {
        return str.trim().replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_]/g, '__');
    }

    function humanReadableDecode(str) {
        return str.replace(/__/g, '-').replace(/_/g, ' ');
    }

    function loadPosts(paged, searchQuery = '', orderby = '') {
        let taxFilter = getTaxFilters();
        let metaFilter = getMetaFilters();

        // If search is used, unset all other filters, clear active filters, and reset labels
        if (searchQuery) {
            taxFilter = {};
            metaFilter = {};
            $('.term-checkbox, .meta-checkbox').prop('checked', false); // Uncheck all filters
            $('.article-active-filters').empty(); // Remove all active filters
            updateLabelCounter(true); // Reset labels
        }

        $.ajax({
            url: vars.ajaxurl,
            type: 'POST',
            data: {
                action: 'load_clanki_posts',
                paged: paged,
                s: searchQuery,
                tax_filter: taxFilter,
                meta_filter: metaFilter,
                orderby: orderby,
                _ajax_nonce: vars.nonce
            },
            beforeSend: function (jqXHR, settings) {
                console.log('Data being sent:', settings.data);
            },
            success: function (response) {
                $('#post-ajax').html(response);
                updateURL(paged, taxFilter, metaFilter);
                updateCount();
            },
            error: function (xhr, status, error) {
                console.log('Error:', error);
            }
        });
    }

    function updateURL(paged, taxFilter, metaFilter) {
        let url = new URL(window.location.href);

        if (paged > 1) {
            url.searchParams.set('paged', paged);
        } else {
            url.searchParams.delete('paged');
        }

        url.searchParams.delete('filters');

        let filters = [];
        Object.keys(taxFilter).forEach(function (taxonomy) {
            let encodedTerms = taxFilter[taxonomy].map(term => humanReadableEncode(term));
            if (encodedTerms.length > 0) {
                filters.push(`${taxonomy}:${encodedTerms.join(',')}`);
            }
        });

        Object.keys(metaFilter).forEach(function (metaKey) {
            filters.push(`meta-${metaKey}`);
        });

        if (filters.length > 0) {
            url.searchParams.set('filters', filters.join('|'));
        }

        history.pushState(null, '', url.toString());
    }

    function updateCount() {
        let counterElement = $('.article-counter-number');
        let paginationElement = $('.article-pagination');
        if (counterElement.length > 0 && paginationElement.length > 0) {
            counterElement.text(paginationElement.attr('data-total'));
        }
    }

    function setFiltersFromURL() {
        let urlParams = new URLSearchParams(window.location.search);
        let page = urlParams.get('paged') || 1;
        let filters = urlParams.get('filters');
        let searchQuery = urlParams.get('s') || '';
        let orderby = urlParams.get('orderby') || $('#orderby').val();

        if (filters) {
            filters.split('|').forEach(function (filter) {
                if (filter.startsWith('meta-')) {
                    let metaKey = filter.split('-')[1];
                    $(`input.meta-checkbox[data-meta-key="${metaKey}"]`).prop('checked', true);
                } else {
                    let [taxonomy, terms] = filter.split(':');
                    if (taxonomy && terms) {
                        terms.split(',').forEach(function (encodedTerm) {
                            let decodedTerm = humanReadableDecode(encodedTerm);
                            $(`input.term-checkbox[data-taxonomy="${taxonomy}"][value="${decodedTerm}"]`)
                                .prop('checked', true)
                                .parent()
                                .addClass('active');                        });
                    }
                }
            });
        }

        $('#orderby').val(orderby); // Set the orderby select value
        $('#article-search-input').val(searchQuery);
        loadPosts(page, searchQuery, orderby); // Pass orderby to loadPosts
    }

    $(document).on('click', '.article-pagination a', function (e) {
        e.preventDefault();
        let paged = $(this).attr('href').split('paged=')[1];
        let searchQuery = $('#article-search-input').val();
        let orderby = $('#orderby').val();
        loadPosts(paged, searchQuery, orderby);
    });

    $('#article-search-button').on('click', function () {
        let searchQuery = $('#article-search-input').val();
        let orderby = $('#orderby').val();
        loadPosts(1, searchQuery, orderby); // Call the loadPosts function with the search query and orderby
    });

    $('#article-search-input').on('keypress', function (e) {
        if (e.which === 13) { // Enter key corresponds to key code 13
            let searchQuery = $(this).val();
            let orderby = $('#orderby').val();
            loadPosts(1, searchQuery, orderby); // Call the loadPosts function with the search query and orderby
        }
    });

    $('#article-filter-box-reset').on('click', function (){
        $('.term-checkbox, .meta-checkbox').prop('checked', false); // Uncheck all filters
        $('.article-active-filters').empty(); // Remove all active filters
        $('.option-wrapper').removeClass('active');
        updateLabelCounter(true); // Reset labels
        let searchQuery = $('#article-search-input').val();
        let orderby = $('#orderby').val();
        loadPosts(1, searchQuery, orderby); // Call the loadPosts function with the search query and orderby
    });

    $('#orderby').on('change', function () {
        let searchQuery = $('#article-search-input').val();
        let orderby = $(this).val();
        loadPosts(1, searchQuery, orderby); // Call the loadPosts function with the new orderby value
    });

    $(document).on('change', '.term-checkbox, .meta-checkbox', function () {
        $('#article-search-input').val('');
        let searchQuery = '';
        let orderby = $('#orderby').val();
        loadPosts(1, searchQuery, orderby);
    });

    setFiltersFromURL();

    function updateLabelCounter(reset = false) {
        $('.article-taxonomy-filter-wrap .explore-label span').each(function () {
            let spanClass = $(this).attr('class');
            let filterLabel = $('span.' + spanClass);

            if (reset) {
                filterLabel.text(filterLabel.attr('data-name')); // Reset label to its default state
            } else {
                const inputs = document.querySelectorAll('input[data-taxonomy="' + spanClass + '"]');
                const checkedInputs = Array.from(inputs).filter(input => input.checked);
                const checkedCount = checkedInputs.length;

                if (checkedCount > 0) {
                    filterLabel.text(filterLabel.attr('data-name') + ' (' + checkedCount + ')');
                } else {
                    filterLabel.text(filterLabel.attr('data-name'));
                }
            }
        });
    }

    function updateActiveFilters() {
        $('.article-taxonomy-filter-wrap .explore-label .explore-options .explore-options-wrapper input').each(function () {
            let name = $(this).attr('name');
            let label = $('label[for="' + name + '"]').text();
            if ($(this).is(':checked')) {
                if ($('.article-active-filters .' + name).length === 0) {
                    $('.article-active-filters').append('<div class="' + name + '">' + label + '</div>');

                    $('.article-active-filters .' + name).on('click', function () {
                        $('.article-taxonomy-filter-wrap .explore-label .explore-options .explore-options-wrapper input[name="' + name + '"]').prop('checked', false);
                        $(this).remove();
                        updateLabelCounter();
                        updateActiveFilters();
                        loadPosts(1);
                    });
                }
            } else {
                $('.article-active-filters .' + name).remove();
            }
        });
        updateURL(1, getTaxFilters(), getMetaFilters());
        loadPosts(1);
    }

    function getTaxFilters() {
        let taxFilter = {};
        $('.term-checkbox').each(function () {
            let taxonomy = $(this).data('taxonomy');
            if (taxonomy && $(this).is(':checked')) {
                if (!taxFilter[taxonomy]) {
                    taxFilter[taxonomy] = [];
                }
                taxFilter[taxonomy].push($(this).val());
            }
        });
        return taxFilter;
    }

    function getMetaFilters() {
        let metaFilter = {};
        $('.meta-checkbox').each(function () {
            let metaKey = $(this).data('meta-key');
            if ($(this).is(':checked')) {
                metaFilter[metaKey] = true;
            }
        });
        return metaFilter;
    }

    updateLabelCounter();
    updateActiveFilters();

    $('.explore-options-wrapper input').on('change', function () {
        updateLabelCounter();
        updateActiveFilters();

        $('.term-checkbox').each(function () {
            if ($(this).is(':checked')) {
                $(this).parent().addClass('active');
            }else {
                $(this).parent().removeClass('active');
            }
        });

    });


    function moveLabels() {
        if ($(window).width() < 989) {
            $('.article-radio-filter-wrap input').each(function() {
                var inputId = $(this).attr('id');
                var label = $('label[for="' + inputId + '"]');

                if (label.length && !$(this).prev('label[for="' + inputId + '"]').length) {
                    label.clone().insertBefore($(this));
                    label.remove();
                }
            });
        }
    }

    moveLabels();

    $(window).resize(function() {
        moveLabels();
    });

    $('#article-filter-box-button, #article-filter-box-use, #article-filter-box-reset, .article-filter-box-close').on('click', function (){
        $('.article-filter-box').toggleClass('show');
    });
});
